<section class="section accounts">
    <div class="">
        <div class="">
            <div class="card-header"><h4 class="mb-0">Bonus List</h4></div>

            <div class="casino-custom-design" >

                <div class="bonus_tabs container">
                    <tabset type="nav-pills my-1 justify-content-center">
                        <tab [heading]="tabDt?.name" *ngFor="let tabDt of tabs;let i=index;trackBy:trackByIndex;">

                            <div class="row mx-0 mt-2" *ngIf="(data && data?.length > 0)">
                                <div class="col-md-4 col-12 px-1" *ngFor="let item of tabDt.data;let i=index;trackBy:trackByIndex;">
                                    <div class="bonus_lists"  [ngClass]="{'bonus-expired' : item.status == 2}">
                                        <h3>{{item?.title}}</h3>
                                        <div class="bonus_lists_first">
                                            <p>
                                                <span>amount: <b>{{item.amount}}</b></span>
                                                <button *ngIf="item.status == 1" (click)="redeemBonusItem(item)" [disabled]="isRedeemLoad">Redeem <i *ngIf="isRedeemLoad" class="mdi mdi-loading mdi-spin"></i></button>
                                                <button *ngIf="item.status == 3" class="success-rdm">Redeemed Successfully</button>
                                                <span>status: <b>{{status[item.status]}}</b></span>
                                            </p>
                
                                            <div class="progress_bar">
                                                <progressbar class="blue" [value]="item?.wager_completed" [max]="item?.wager_target" [striped]="true"></progressbar>
                                                <div class="progress-label">{{calculatePercentage(item)}} % ({{item.wager_completed}})</div>
                                                <!-- <progress class="blue" value="35" max="70"></progress> -->
                                                <p>
                                                    <span>0</span>
                                                    <span>{{item.wager_target}}</span>
                                                </p>
                                            </div>
                                        </div>
                
                                        <div class="bonus_lists_second">
                                            <h2>{{types[item.type]}}</h2>
                                            <div class="row">
                                                <div class="col-6 text-left">
                                                    <b>request date:</b> {{item.created_at_format | date: 'dd/MM/YYYY hh:mm:ss a'}}
                                                </div>
                                                <div class="col-6 text-left">
                                                    <b>expire date:</b> {{item.expire_date_format | date: 'dd/MM/YYYY hh:mm:ss a'}}
                                                </div>
                                            </div>
                                        </div>
                                        <accordion [isAnimated]="true">
                                            <accordion-group heading="Comments">
                                                Dear Users, All your bonuses  will now be divided into 10 Equal coupons each. Eg: If the bonus received is Rs. 10000, it will be split into (10000/ 10) = 1000,    10 coupons of 1000 each. 
                                                Every coupon is available for redeem after required Rolling for coupon amount completed Eg: If the required Rolling is 100X,  to redeem1000 awaiting bonus , you have to make turn over of 1,00,000.
                                                The bonus can be used to place bets and winnings earned from the bonus amount can be withdrawn. 
                                                NOTE
                                                1. A New user will not Receive the First Deposit Bonus if the same Device ( Computer, laptop, mobile) is used to make multiple accounts.
                                                2. Turn over in LIVE CASINO will be considered on certain casino games. 
                                                3. Awaiting Bonus will be expire in 14 days.
                                            </accordion-group>
                                        </accordion>
                                    </div>                                    
                                </div>

                                <div class="col-md-12 col-12 px-1" *ngIf="tabDt.data.length == 0">
                                    <span style="color: #fff;font-size: 13px;padding: 10px;">No data found</span>
                                </div>
                            </div>
                            
                        </tab>
                    </tabset>
                </div>
            </div>
            
           

            <!-- <app-loader class="no-overlay" *ngIf="isLoad"></app-loader> -->


        </div>
    </div>
</section>